import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseURL, getUser } from "../redux/Action";
import { AiFillGithub } from "react-icons/ai";
import { FcGoogle } from "react-icons/fc";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const { isAuth } = useSelector((state) => state);
  const [signin, setSignin] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Blogshog | Signin";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignin({
      ...signin,
      [name]: value,
    });
  };

  if (isAuth) {
    return <Navigate to={"/"} />;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const id = toast.loading("Signing in...", { theme: "dark" });
    axios
      .post(`${baseURL}/signin`, signin, { withCredentials: true })
      .then((res) => {
        if (res.status === 201) {
          toast.update(id, {
            render: res.data.status,
            type: "success",
            isLoading: false,
            theme: "dark",
            autoClose: 2000,
            closeOnClick: true,
          });
          localStorage.setItem("jwtoken", res.data.token);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          getUser(dispatch);
          navigate("/");
        }
      })
      .catch((err) => {
        toast.update(id, {
          render: "Invalid Details",
          type: "error",
          isLoading: false,
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };
  return (
    <>
      {" "}
      <div className="flex lg:pt-16 justify-center h-[80vh] px-4 sm:px-6 lg:px-8 dark:text-white">
        <div className="max-w-md w-full">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
              Sign in to your account
            </h2>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm dark:bg-[#333549] dark:border-gray-900 dark:text-white"
                  placeholder="Email address"
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <div className="relative w-full">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    required
                    className="rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm dark:bg-[#333549] dark:border-gray-900 dark:text-white"
                    placeholder="Password"
                    onChange={handleChange}
                  />
                  {showPassword && (
                    <FaEye
                      className="absolute top-3 right-5 cursor-pointer text-gray-500 z-20"
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  )}
                  {!showPassword && (
                    <FaEyeSlash
                      className="absolute top-3 right-5 cursor-pointer text-gray-500 z-20"
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  )}
                </div>
              </div>
            </div>
            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                Sign in
              </button>
              <a
                href={`https://github.com/login/oauth/authorize?client_id=${process.env.REACT_APP_CLIENTID}`}
                className="flex items-center bg-slate-800 text-white rounded-lg mt-2 cursor-pointer hover:bg-black px-4 py-2 font-medium justify-center"
              >
                <AiFillGithub className="text-2xl" />
                <p className="pl-4 ">Sign in with GitHub</p>
              </a>
              <a
                href={`https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=https%3A%2F%2Ffull-stack-blog-application-mu.vercel.app%2Fauth%2Fgoogle%2Fcallback&client_id=${process.env.REACT_APP_GOOGLE_CLIENTID}&response_type=code&prompt=consent&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email`}
                className="flex items-center  rounded-lg mt-2 cursor-pointer hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-black dark:border-none shadow-sm border px-4 py-2 font-medium justify-center"
              >
                <FcGoogle className="text-2xl" />
                <p className="pl-4 ">Sign in with Google</p>
              </a>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
